module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-arrange-b74141b706423650029c2e1b1a04c0c9.svg";